/**
 * Date-extensions locale Uzbek Latin [uz-latn]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('uz-latn', {
    monthNames: ['Yanvar','Fevral','Mart','Aprel','May','Iyun','Iyul','Avgust','Sentabr','Oktabr','Noyabr','Dekabr'],
    monthShortNames: ['Yan','Fev','Mar','Apr','May','Iyun','Iyul','Avg','Sen','Okt','Noy','Dek'],
    dayNames: ['Yakshanba','Dushanba','Seshanba','Chorshanba','Payshanba','Juma','Shanba'],
    dayShortNames: ['Yak','Dush','Sesh','Chor','Pay','Jum','Shan']
});
